import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=26633039&"
import script from "./Admin.ts?vue&type=script&lang=ts&"
export * from "./Admin.ts?vue&type=script&lang=ts&"
import style0 from "./Admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports